<template>
	<div>
		<input
			v-if="facet.visible"
			:id="facet.name"
			v-model="facet.checked"

			type="checkbox"
			:name="group.id"
			class="form__chr--square-check c-content__input"
			:value="facet.value"
			:disabled="facet.count === 0"
			@change="performSearchWithFilters"
		/>
		<label
			v-if="facet.visible"
			:for="facet.name"
			class="facet__list__select__label c-content__label"
			:class="[
				facet.checked ? 'facet__list__select__label--checked' : '',
				facet.count === 0 ? 'facet__list__select__label--disabled' : 'facet__list__select__label--not-disabled',
				isFiltersDisabled ? 'facet__list__select__label--inactive' : ''
			]"
			itemprop="itemListElement"
			itemscope=""
			itemtype="https://schema.org/ListItem"
		>
			<span>
				<meta itemprop="name" content="facet" />
				<span itemprop="additionalProperty" itemscope itemtype="https://schema.org/PropertyValue">
					<meta itemprop="name" :content="facet.value" />
					<span itemprop="value">
						{{ facet.value }}
						<span class="facet__count">({{ facet.count }})</span>
					</span>
				</span>
			</span>
		</label>
	</div>
</template>

<script>
	import { mapGetters, mapMutations, mapActions } from 'vuex';

	export default {
		name: 'content-facet-item',
		props: ['facet', 'group'],
		computed: {
			...mapGetters({
				activeLibraryFilters: 'getActiveLibraryFilters',
				isFiltersDisabled: 'getIsFiltersDisabled'
			}),
		},
		methods: {
			...mapMutations(['setActiveFiltersCategories']),
			...mapActions(['executeSearchWithFilters']),
			performSearchWithFilters() {

				let filtersArray = this.activeLibraryFilters[this.group.id] ? this.activeLibraryFilters[this.group.id] : [];
				if (this.facet.checked) {
					filtersArray.push(this.facet.name);
					this.setActiveFiltersCategories({ group: this.group.id, items: filtersArray });
				} else {
					if (filtersArray.length === 1) {
						this.setActiveFiltersCategories({ group: this.group.id });
					} else {
						const index = filtersArray.indexOf(this.facet.name);
						filtersArray.splice(index, 1);
						this.setActiveFiltersCategories({ group: this.group.id, items: filtersArray });
					}
				}
				this.executeSearchWithFilters();
			},
		},
	};
</script>
